import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { IncidentListItem } from './incidents/IncidentListItem';

export const RecentIncidentsCard = () => {
  const { authAxios } = useAuth();
  const [reports, setReports] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    authAxios.get('/incident-reports').then((r) => setReports(r.data.filter((x) => x.status !== 'closed').slice(0, 5))).catch(() => {});
  }, [authAxios]);

  return (
    <Card className="border-0 shadow-lg shadow-stone-200/50 bg-white mb-8" data-testid="recent-incidents-card">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-lg font-heading flex items-center gap-2">
          <ShieldAlert className="w-5 h-5 text-rose-600" />
          Open Incident Reports
          {reports.length > 0 && <span className="text-sm font-mono text-rose-600" data-testid="open-incidents-count">({reports.length})</span>}
        </CardTitle>
        <Link to="/admin/incident-reports">
          <Button variant="ghost" size="sm" className="text-rose-600 hover:text-rose-700" data-testid="view-all-incidents-btn">
            View All <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </Link>
      </CardHeader>
      <CardContent>
        {reports.length === 0 ? (
          <p className="text-center py-6 text-stone-400">No open incidents</p>
        ) : (
          <div className="space-y-2">
            {reports.map((r) => (
              <IncidentListItem key={r.id} report={r} onOpen={() => navigate('/admin/incident-reports')} showReporter />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
